import { bonusesConstants } from "./constants";

export const bonusesLoaded = (bonuses) => ({
  type: bonusesConstants.SET,
  bonuses: bonuses
});
